import { ViewPort } from "../../../../Engine/View/ViewPort";
import { mat4, vec3 } from "gl-matrix";
import { toRadian } from "../../../../Common/Math/math";

export class GameViewPort extends ViewPort {

    public applyModelView(matrix: mat4): mat4 {
        this.rotation = this.rotation % 360;

        var pitch = this.lookDirection;
        var yaw = -this.rotation;
        /*
        mat4.rotate(matrix, matrix, glMatrix.toRadian(-pitch), [1, 0, 0]);
        mat4.rotate(matrix, matrix, glMatrix.toRadian(-yaw), [0, 1, 0]);
    	
        mat4.rotate(matrix, matrix, glMatrix.toRadian(90.0), [1, 0, 0]);
    	
        mat4.translate(matrix, matrix, vec3.fromValues(-this.x, -this.y, -this.z));*/

        var dist = 25;

        mat4.lookAt(matrix,
            vec3.fromValues( // camera
                this.x + dist * Math.sin(toRadian(this.rotation)), // rotate around the location
                this.y + dist * Math.cos(toRadian(this.rotation)),
                this.z + 10 // Up in the air a bit
            ),
            vec3.fromValues(this.x, this.y, this.z), // location
            vec3.fromValues(0, 0, 1) // z is up
        );

        return matrix;
    }
}